import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const UpcomingAppointments = ({ appointments, onScheduleNew }) => {
  return (
    <div className="bg-card rounded-xl shadow-elevation-2 border border-border p-4 md:p-6">
      <div className="flex items-center justify-between mb-4 md:mb-6">
        <h3 className="text-base md:text-lg font-semibold text-foreground">Upcoming Appointments</h3>
        <Button variant="outline" size="sm" iconName="Plus" onClick={onScheduleNew}>
          <span className="hidden sm:inline">Schedule</span>
        </Button>
      </div>
      {appointments?.length === 0 ? (
        <div className="text-center py-6 md:py-8">
          <Icon name="Calendar" size={40} className="mx-auto mb-3 text-muted-foreground" />
          <p className="text-sm md:text-base text-muted-foreground mb-4">No upcoming appointments</p>
          <Button variant="default" size="sm" iconName="Plus" onClick={onScheduleNew}>
            Schedule Appointment
          </Button>
        </div>
      ) : (
        <div className="space-y-3">
          {appointments?.map((appointment, index) => (
            <div
              key={index}
              className="flex items-start gap-3 p-3 md:p-4 bg-muted/50 rounded-lg transition-smooth hover:bg-muted"
            >
              <div className="flex items-center justify-center w-10 h-10 bg-primary/10 rounded-lg flex-shrink-0">
                <Icon name="Calendar" size={20} color="var(--color-primary)" />
              </div>
              
              <div className="flex-1 min-w-0">
                <h4 className="text-sm md:text-base font-semibold text-foreground mb-1">{appointment?.type}</h4>
                
                <div className="space-y-1 text-xs md:text-sm text-muted-foreground">
                  <div className="flex items-center gap-2">
                    <Icon name="Clock" size={14} />
                    <span>{appointment?.date} at {appointment?.time}</span>
                  </div>
                  <div className="flex items-center gap-2">
                    <Icon name="User" size={14} />
                    <span>{appointment?.provider}</span>
                  </div>
                  {appointment?.location && (
                    <div className="flex items-center gap-2">
                      <Icon name="MapPin" size={14} />
                      <span>{appointment?.location}</span>
                    </div>
                  )}
                </div>
              </div>
              
              <Button variant="ghost" size="sm" iconName="ChevronRight" />
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default UpcomingAppointments;